import { render } from "./dialysis_index.vue?vue&type=template&id=2e3e4cea&scoped=true"
import script from "./dialysis_index.vue?vue&type=script&lang=js"
export * from "./dialysis_index.vue?vue&type=script&lang=js"

import "./dialysis_index.vue?vue&type=style&index=0&id=2e3e4cea&scoped=true&lang=css"

import exportComponent from "/home/denoh/aiwork/second/in_client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2e3e4cea"]])

export default __exports__